export const isExpiredTokenHelper = (intDate?: number): boolean => {
  return Boolean(!intDate || intDate * 1000 < Date.now());
};
